// ID4 · ¿la pestaña está a la vista? Sólo gobierna los LECTORES EKH (mosaico, mini curvas y ficha).
// No se usa para eventos, alertas ni atención: esos siguen su propio ciclo.
import { useEffect, useState } from "react";

function visibleAhora() {
  if (typeof document === "undefined") return true;
  return document.visibilityState !== "hidden";
}

export default function useDocumentoVisible() {
  const [visible, setVisible] = useState(visibleAhora);
  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    const al = () => setVisible(visibleAhora());
    document.addEventListener("visibilitychange", al);
    return () => document.removeEventListener("visibilitychange", al);
  }, []);
  return visible;
}
